export enum LeagueStatus {
    INACTIVE = 0,
    ACTIVE = 1,
    FINISHED = 2,
    PUBLISHING = 7,
    DELETED = 8,
}
